import { SplitOrderInvoicesDetailModel, SplitOrderInvoicesDetailPageState } from './split_order_invoices_detail_types';

export function splitOrderInvoicesDetailPageStateVM(): SplitOrderInvoicesDetailPageState {
    return {
        init: true,
        canEdit: false,
        waiting: false,
        title: '',
        id: '',
        rebatesOnly: false,
        userType: '',
        userAffList: [],
        isVeriSaveOnly: false,
        lineitemselected: null,
    };
}

export function splitOrderInvoicesDetailModelVM(): SplitOrderInvoicesDetailModel {
    return {
        Id: '',
        CEID: '',
        Pharmacy: '',
        AccumGrp: '',
        OrderNum: '',
        CreatedDate: '',
        Type: '',
        VendorName: '',
        VendorInvoiceNum: '',
        VendorInvoiceDate: '',
        BillNumber: '',
        InvoiceReconciledDate: '',
        TotalAmount: 0,
        Reviewer: '',
        Items: [],
        IsRebate: false,
        AccumRXID: '',
    };
}
